export default {
  title: "Task Center",
  "onplus-title": "Point Center",
  point: "Point",
  "point-earn-title": "Earn RedCoins",
  "point-earn-subtitle": "Complete tasks to save money",
  "show-histroy-text": "History",
  "go-button-text": "Go",
  "done-button-text": "Done",
  history: {
    title: "Point History",
    "error-text": "network error",
    totalAmount: "Total Amount",
  },
};
